import { ContentSection } from '@bw/apis/contentful';

export type Size = NonNullable<ContentSection<undefined>['fields']['size']>;

type SizeMap = {
	[key in Size]: string;
};

export const sizeToClassMap: SizeMap = {
	Hero: 'hero',
	Big: 'big',
	Medium: 'medium',
	Small: 'small',
};
